const state = {
  currencyList: [],
  countryList: [],
  countryCurrencyList: [],
  fundList: [],
  userAccountList: [],
}
const getters = {
  getCurrencyList: (state) => state.currencyList,
  getCurrencyByCode: (state) => (code) => {
    return state.currencyList.find((currency) => currency.code === code)
  },
  getCountryList: (state) => state.countryList,
  getCountryByCode: (state) => (code) => {
    return state.countryList.find((country) => country.code === code)
  },
  getCountryCurrencyList: (state) => state.countryCurrencyList,

  getFundList: (state) => state.fundList,
  getFundByCode: (state) => (code) => {
    return state.fundList.find((fund) => fund.code === code)
  },
  getUserAccountList: (state) => state.userAccountList,
  getUserAccountById: (state) => (id) => {
    return state.userAccountList.find((account) => account.id === id)
  },
}

const mutations = {
  SET_CURRENCY_LIST(state, currencyList) {
    state.currencyList = currencyList
  },
  SET_COUNTRY_LIST(state, countryList) {
    state.countryList = countryList
  },
  SET_COUNTRY_CURRENCY_LIST(state, countryCurrencyList) {
    state.countryCurrencyList = countryCurrencyList
  },
  SET_FUND_LIST(state, fundList) {
    state.fundList = fundList
  },
  SET_USER_ACCOUNT_LIST(state, userAccountList) {
    state.userAccountList = userAccountList
  },
}
const actions = {
  setCurrencyList({ commit }, currencyList) {
    commit('SET_CURRENCY_LIST', currencyList)
  },
  setCountryList({ commit }, countryList) {
    commit('SET_COUNTRY_LIST', countryList)
  },
  setCountryCurrencyList({ commit }, countryCurrencyList) {
    commit('SET_COUNTRY_CURRENCY_LIST', countryCurrencyList)
  },
  setFundList({ commit }, fundList) {
    commit('SET_FUND_LIST', fundList)
  },
  setUserAccountList({ commit }, userAccountList) {
    commit('SET_USER_ACCOUNT_LIST', userAccountList)
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
